import { render, staticRenderFns } from "./c-select-test@.vue?vue&type=template&id=5bae2756&"
import script from "./c-select-test@.vue?vue&type=script&lang=ts&"
export * from "./c-select-test@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports